import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("apex_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    // Clear stale auth on 401 or a role-mismatch 403 (never on the login/auth calls themselves)
    const isAuthCall = url.includes("/auth/login") || url.includes("/auth/register") || url.includes("/auth/forgot-password") || url.includes("/auth/reset-password");
    if (!isAuthCall && (status === 401 || status === 403)) {
      localStorage.removeItem("apex_token");
      localStorage.removeItem("apex_user");
      // Redirect to the right login page based on the failed request
      if (typeof window !== "undefined") {
        const path = window.location.pathname;
        if (!path.startsWith("/login") && !path.startsWith("/admin/login") && !path.startsWith("/driver/login")) {
          const dest = path.startsWith("/admin") ? "/admin/login" : path.startsWith("/driver") ? "/driver/login" : "/login";
          window.location.replace(dest);
        }
      }
    }
    return Promise.reject(err);
  }
);

export const getUser = () => {
  try {
    const raw = localStorage.getItem("apex_user");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const setAuth = (token, user) => {
  localStorage.setItem("apex_token", token);
  localStorage.setItem("apex_user", JSON.stringify(user));
};

export const clearAuth = () => {
  localStorage.removeItem("apex_token");
  localStorage.removeItem("apex_user");
};
